module.exports = __webpack_public_path__ + "static/media/Chinmayi.16a4deaf.svg";